(function(){
  function init(root){
    if(!root || root.dataset.ready==='1') return;
    root.dataset.ready='1';
    root.querySelectorAll('[data-kp-carousel]').forEach(function(rail){
      var name=rail.getAttribute('data-kp-carousel');
      if(name==='proof'){
        var originals=Array.from(rail.children).slice(0,4);
        rail.replaceChildren.apply(rail,originals);
        var reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
        function buildLoop(){
          rail.querySelectorAll('[data-kp-loop-copy]').forEach(function(node){node.remove();});
          var card=originals[0],gap=parseFloat(getComputedStyle(rail).columnGap)||24;
          var cycle=(card.getBoundingClientRect().width+gap)*2;
          var repeats=Math.ceil(window.innerWidth/cycle)+2;
          for(var n=0;n<repeats;n++)originals.forEach(function(node){var copy=node.cloneNode(true);copy.dataset.kpLoopCopy='true';copy.setAttribute('aria-hidden','true');copy.querySelectorAll('a,button').forEach(function(a){a.tabIndex=-1;});rail.appendChild(copy);});
          rail.style.setProperty('--kp330-loop-distance',cycle+'px');
          rail.style.setProperty('--kp330-loop-duration',(cycle/24)+'s');
          rail.dataset.kpLoopDistance=String(cycle);
          rail.classList.toggle('kp330-reduced',reduced.matches);
        }
        buildLoop();window.addEventListener('resize',buildLoop);reduced.addEventListener('change',buildLoop);
        return;
      }
      var next=root.querySelector('[data-kp-carousel-next="'+name+'"]');
      var prev=root.querySelector('[data-kp-carousel-prev="'+name+'"]');
      function amount(){
        var card=rail.firstElementChild;
        var style=window.getComputedStyle(rail);
        var gap=parseFloat(style.columnGap || style.gap || '0') || 0;
        return card ? card.getBoundingClientRect().width + gap : 300;
      }
      function updateState(step){
        var index=parseInt(rail.dataset.kpIndex || '0',10) || 0;
        rail.dataset.kpIndex=String(index + step);
        rail.dataset.kpFirstCard=(rail.firstElementChild && rail.firstElementChild.textContent || '').trim().slice(0,48);
      }
      function rotate(step){
        if(rail.children.length < 2) return;
        if(step > 0){
          rail.appendChild(rail.firstElementChild);
        }else{
          rail.insertBefore(rail.lastElementChild, rail.firstElementChild);
        }
        updateState(step);
      }
      function move(step){
        var before=rail.scrollLeft;
        var maxScroll=Math.max(0, rail.scrollWidth - rail.clientWidth);
        if(maxScroll > 2){
          var current=parseInt(rail.dataset.kpIndex || '0',10) || 0;
          var nextIndex=Math.max(0,Math.min(rail.children.length-1,current+step));
          var first=rail.firstElementChild;
          var target=rail.children[nextIndex];
          var left=target && first ? target.offsetLeft-first.offsetLeft : before+(amount()*step);
          rail.scrollTo({left:left,behavior:'smooth'});
          rail.dataset.kpIndex=String(nextIndex);
          rail.dataset.kpFirstCard=(target && target.textContent || '').trim().slice(0,48);
          return;
        }
        rotate(step);
      }
      updateState(0);
      next && next.addEventListener('click',function(){move(1);});
      prev && prev.addEventListener('click',function(){move(-1);});
    });
    root.querySelectorAll('.kp113-faq details').forEach(function(detail){
      detail.addEventListener('toggle',function(){
        if(!detail.open) return;
        root.querySelectorAll('.kp113-faq details').forEach(function(other){if(other!==detail)other.open=false;});
      });
    });
    var timeline=root.querySelector('.kp113-timeline');
    var comparison=root.querySelector('.kp113-compare');
    if(timeline && comparison && timeline.nextElementSibling===comparison){root.insertBefore(comparison,timeline);}
    if(timeline && !timeline.dataset.scrollMotion){
      timeline.dataset.scrollMotion='true';
      var motionPreference=window.matchMedia('(prefers-reduced-motion: reduce)');
      var stage=document.createElement('div');
      stage.className='kp113-timeline__stage';
      while(timeline.firstChild)stage.appendChild(timeline.firstChild);
      timeline.appendChild(stage);
      var motionSteps=Array.from(timeline.querySelectorAll('.kp113-tl__step')).map(function(step){
        var content=document.createElement('div');
        content.className='kp113-tl__motion';
        while(step.firstChild)content.appendChild(step.firstChild);
        step.appendChild(content);
        return {step:step,content:content};
      });
      var motionFrame=0;
      function renderTimeline(){
        motionFrame=0;
        var compactViewport=window.innerWidth>2200||window.innerHeight>1300;
        var enabled=!motionPreference.matches&&!compactViewport;
        timeline.classList.toggle('is-scroll-story',enabled);
        timeline.classList.toggle('is-compact-story',compactViewport);
        var header=root.querySelector('.kp113-header');
        var inset=header?header.getBoundingClientRect().height:80;
        var minHeight=window.innerWidth<750?520:560;
        var maxHeight=window.innerWidth<750?620:700;
        var height=Math.max(minHeight,Math.min(maxHeight,window.innerHeight-inset));
        var motionTravel=height*2;
        var sectionTravel=height*3;
        if(enabled){
          timeline.style.setProperty('height',(height+sectionTravel)+'px','important');
        }else{
          timeline.style.removeProperty('height');
        }
        stage.style.height=enabled?height+'px':'';
        stage.style.setProperty('--kp-story-inset',enabled?inset+'px':'');
        var offset=Math.max(0,Math.min(sectionTravel,inset-timeline.getBoundingClientRect().top));
        var raw=2*Math.min(motionTravel,offset)/motionTravel;
        var index=Math.floor(raw);
        var transition=Math.max(0,Math.min(1,(raw-index-.45)/.55));
        var progress=index+transition*transition*(3-2*transition);
        motionSteps.forEach(function(item,i){
          var distance=progress-i;
          var visible=!enabled||Math.abs(distance)<1;
          item.step.style.visibility=visible?'visible':'hidden';
          item.step.setAttribute('aria-hidden',enabled&&Math.abs(distance)>.5?'true':'false');
          item.content.style.transform=enabled?'translate3d(0,'+(distance*110).toFixed(2)+'%,0)':'';
          item.content.style.opacity=enabled?String(Math.max(0,1-Math.abs(distance))):'1';
        });
      }
      function queueTimeline(){
        if(!root.isConnected){window.removeEventListener('scroll',queueTimeline);window.removeEventListener('resize',queueTimeline);motionPreference.removeEventListener('change',queueTimeline);return;}
        if(!motionFrame)motionFrame=window.requestAnimationFrame(renderTimeline);
      }
      window.addEventListener('scroll',queueTimeline,{passive:true});
      window.addEventListener('resize',queueTimeline,{passive:true});
      motionPreference.addEventListener('change',queueTimeline);
      renderTimeline();
    }
    var sticky=root.querySelector('.kp113-mobile-sticky');
    var hero=root.querySelector('.kp113-hero');
    var footer=document.querySelector('.kp113-footer');
    if(sticky && hero && footer){
      var syncSticky=function(){
        var narrow=window.matchMedia('(max-width:980px)').matches;
        var heroBottom=hero.getBoundingClientRect().bottom;
        var footerTop=footer.getBoundingClientRect().top;
        var visible=narrow && heroBottom < 0 && footerTop > 0;
        sticky.classList.toggle('is-visible',visible);
        if(visible){
          sticky.style.bottom=Math.max(0,window.innerHeight-footerTop)+'px';
        }else{
          sticky.style.removeProperty('bottom');
        }
      };
      syncSticky();
      window.addEventListener('scroll',syncSticky,{passive:true});
      window.addEventListener('resize',syncSticky,{passive:true});
    }
  }
  document.querySelectorAll('[data-kp113-root]').forEach(init);
  document.addEventListener('shopify:section:load',function(event){init(event.target.querySelector('[data-kp113-root]'));});
})();
